import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

const SidebarContainer = styled.aside`
  width: 250px;
  background-color: #ffffff;
  box-shadow: 1px 0 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem 0;
`;

const SidebarSection = styled.div`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h3`
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 0 1.5rem;
  margin-bottom: 0.75rem;
`;

const NavItem = styled(Link)<{ active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  color: ${({ active }) => (active ? '#2563eb' : '#4b5563')};
  background-color: ${({ active }) => (active ? '#eff6ff' : 'transparent')};
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    background-color: ${({ active }) => (active ? '#eff6ff' : '#f9fafb')};
  }
`;

const Sidebar: React.FC = () => {
  const location = useLocation();
  
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };
  
  return (
    <SidebarContainer>
      <SidebarSection>
        <SectionTitle>Trading</SectionTitle>
        <NavItem to="/" active={isActive('/')}>
          Dashboard
        </NavItem>
        <NavItem to="/presets" active={isActive('/presets')}>
          Presets
        </NavItem>
        <NavItem to="/positions" active={isActive('/positions')}>
          Positions
        </NavItem>
      </SidebarSection>
      
      <SidebarSection>
        <SectionTitle>Settings</SectionTitle>
        <NavItem to="/settings" active={isActive('/settings')}>
          General Settings
        </NavItem>
        <NavItem to="/api-keys" active={isActive('/api-keys')}>
          API Keys
        </NavItem>
      </SidebarSection>
    </SidebarContainer>
  );
};

export default Sidebar; 